import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'IndexPage',
      component: () => import('@/components/IndexPage')
    },
    {
      path: '/payments',
      name: 'Payments',
      component: () => import('@/components/pages/payments')
    },
    {
      path: '/recharge',
      name: 'Recharge',
      component: () => import('@/components/pages/recharge')
    },
    {
      path: '/transfers',
      name: 'Transfers',
      component: () => import('@/components/pages/transfers')
    },
    {
      path: '/chat',
      name: 'Chat',
      component: () => import('@/components/pages/chat')
    },
    {
      path: '/charity',
      name: 'Charity',
      component: () => import('@/components/pages/charity')
    },
    {
      path: '/customer-care',
      name: 'CustomerCare',
      component: () => import('@/components/pages/customerCare')
    },
    {
      path: '/cashback',
      name: 'Cashback',
      component: () => import('@/components/pages/cashback')
    },
    {
      path: '/group-payments',
      name: 'GroupPayments',
      component: () => import('@/components/pages/groupPayments')
    },
    {
      path: '/vendors',
      name: 'Vendors',
      component: () => import('@/components/pages/vendors')
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      component: () => import('@/components/pages/aboutUs')
    },
    {
      path: '/careers',
      name: 'Careers',
      component: () => import('@/components/pages/careers')
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: () => import('@/components/pages/faq')
    },
    {
      path: '/privacy-policy',
      name: 'Privacy',
      component: () => import('@/components/pages/privacy')
    },
    {
      path: '/terms',
      name: 'Terms',
      component: () => import('@/components/pages/terms')
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js